// extracted by mini-css-extract-plugin
export default {"integrations":"integrations-wkhFi"};